module.exports = __webpack_public_path__ + "img/send-msg.f6c3ddf1.svg";